(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTrWorkOrderTypeAttributeDeleteController',CustomTrWorkOrderTypeAttributeDeleteController);

    CustomTrWorkOrderTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomTrWorkOrderTypeAttribute'];

    function CustomTrWorkOrderTypeAttributeDeleteController($uibModalInstance, entity, CustomTrWorkOrderTypeAttribute) {
        var vm = this;

        vm.customTrWorkOrderTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomTrWorkOrderTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
